import store from '@/store'
import { Mapper } from '@/db/Mapper';
import { DeckSummaryModel } from '@/models/DeckSummaryModel';
import { Repository } from '@/db/_repo';
import { DeckModel } from '@/models/deck';
const db = new Repository();

export class DeckService {

    deckDueCardsCount(deckId) {
        let deck = store.getters.privateUserDecks.find(x => x.id === deckId) || store.getters.sharedUserDecks.find(x => x.id === deckId);
        if (!deck){
            return;
        }
        let cards = deck.cards;
        const dueCards = cards.filter((card) => {
            // nothing is due - there are no userAnswers
            if (!store.getters.allUserAnswers) {
                return false;
            }

            if (store.getters.allUserAnswers.some(ua => ua.cardGuid === card.guid)) {
                if (store.getters.dueUserAnswers.some(ua => ua.cardGuid === card.guid)) {
                    return true
                }
                return false;
            }
            else {
                // there is no user answer for this card, so don't show it as 'due'
                return false;
            }
        })

        return dueCards.length;

    }

    public async getDueDecksAsync(userId: string): Promise<DeckSummaryModel[]> {
        let mapper = new Mapper(DeckSummaryModel);
        // for now, just using due card notifications, not user answers
        // we might should refactor: https://gitlab.com/liscioapps/quizme/issues/348
        // let dueUserAnswers = await this.getDueUserAnswersAsync(userId);
        const _repo = new Repository();
        let dueCards = await db.learning.dueCardsByUser(userId);
        let userDecks = await db.decks.getUserDecksAsync(userId);
        let sharedDecks = await db.decks.getUserSharedDecksAsync(userId);
        let allDecks = userDecks;
    
        if (sharedDecks) {
          allDecks.concat(sharedDecks);
        }

        let deckSummaries = mapper.MapList(this.mapDeckToDeckSummary, allDecks);
    
        if (deckSummaries !== null) {
          deckSummaries.forEach(deck => {
            if (!dueCards) {
              deck.notificationCount = 0;
            } else {
              deck.notificationCount = this.deckDueCardsCount(deck.id);
            }
          });
        }
    
        return deckSummaries;
      }
      
      private mapDeckToDeckSummary(deck: DeckModel, deckSummary: DeckSummaryModel): DeckSummaryModel {
        deckSummary.id = deck.id;
        deckSummary.name = deck.name;
        deckSummary.desc = deck.desc;
        deckSummary.lastupdatedAt = deck.lastupdatedAt;
        deckSummary.cards = deck.cards;
        deckSummary.visibility = deck.visibility;
        return deckSummary;
      }
}